import {useState, useEffect} from 'react'
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from '../../app/errors'
import { ValidateString } from '../../app/utils'
import { ErrorWithString } from '../RegularComponents'
/*
 * Re-usable input form. We can move this to RegularComponent.js, if it is needed by other screens also.
 * for not its fine here.
 * 
 * props :
 *  - id : The id of the component. This string will be appended by input type.
 *  - onInputChange : The change callback handler. 
 *                    This function will pass the whole object even if just one field is modified.
 *  - disabled : The flag to indicate if the inputs should be disalbed or not. 
 *               The disabled input will not show any value typed in that input box. The state values will 
 *               still be maintained.
 *   - 
 */ 
const ContactDetailsInputForm = (props) => {

    const [contactInput,setContactInput] = useState(props.preloadInput)
    const [showDataValidationError, setShowDataValidationError] = useState(props.showValidationError)

    const [firstNameValidationError, setFirstNameValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [lastNameValidationError, setLastNameValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [phoneNumberValidationError, setPhoneNumberValidationError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [emailValidationError, setEmailValidationError] = useState(VALIDATION_ERROR.NO_ERROR)

    useEffect(() => { 
        const validateFirstName = () => { 
            const ret = ValidateString(contactInput.firstName, VALIDATION_TYPE.NAME)
            setFirstNameValidationError(ret)
            return (ret !== VALIDATION_ERROR.NO_ERROR)
        }
    
        const validateLastName = () => { 
            const ret = ValidateString(contactInput.lastName, VALIDATION_TYPE.NAME)
            setLastNameValidationError(ret)
            return (ret !== VALIDATION_ERROR.NO_ERROR)
        }
    
        const validatePhoneNumber = () => { 
            const ret = ValidateString(contactInput.phoneNumber, VALIDATION_TYPE.PHONE_NUMBER)
            setPhoneNumberValidationError(ret)
            return (ret !== VALIDATION_ERROR.NO_ERROR)
        }
    
        const validateEmail = () => { 
            const ret = ValidateString(contactInput.emailAddress, VALIDATION_TYPE.EMAIL)
            setEmailValidationError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        setContactInput(props.preloadInput)
        setShowDataValidationError(props.showValidationError)

        if(props.showValidationError) { 
            validateFirstName()
            validateLastName()
            validatePhoneNumber()
            validateEmail()
        }

    }, [
        setContactInput,
        setShowDataValidationError, 
        props.showValidationError,
        props.preloadInput,
        contactInput.firstName,
        contactInput.lastName,
        contactInput.phoneNumber,
        contactInput.emailAddress
    ])

    const isFirstNameValid = () => { 
        if(showDataValidationError)
            return (firstNameValidationError === VALIDATION_ERROR.NO_ERROR)

        return true
    }

    const isLastNameValid = () => { 
        if (showDataValidationError)
            return (lastNameValidationError === VALIDATION_ERROR.NO_ERROR)
        return true
    }

    const isPhoneNumberValid = () => { 
        if(showDataValidationError)
            return (phoneNumberValidationError === VALIDATION_ERROR.NO_ERROR)
        return true
    }

    const isEmailValid = () => { 
         if(showDataValidationError)
            return(emailValidationError === VALIDATION_ERROR.NO_ERROR)
        return true 
    }

    const phoneNumberErrorString = () => { 
        switch(phoneNumberValidationError) { 
            case VALIDATION_ERROR.PHONE_NUMBER_INVALID : 
                return ERROR_STRING.CONTACT_DETAILS_PHONE_INVALID
            case VALIDATION_ERROR.EMPTY : 
            default :
                return ERROR_STRING.CONTACT_DETAILS_PHONE_EMPTY
        }
    }

    const emailErrorString = () => {
        switch(emailValidationError) { 
            case VALIDATION_ERROR.EMAIL_INVALID : 
                return ERROR_STRING.CONTACT_DETAILS_EMAIL_INVALID
            case VALIDATION_ERROR.EMPTY :
            default : 
                return ERROR_STRING.CONTACT_DETAILS_EMAIL_EMPTY 
        }
    }

    const onInputChange = (e) => {
        let update = {}
        switch (e.target.id) {
            case props.id + "-first-name":
                update = {firstName : e.target.value}
                break;
            case props.id + '-last-name' :
                update =  {lastName : e.target.value}
                break;
            case props.id + '-phone' :
                update = {phoneNumber : e.target.value}
                break;
            case props.id + '-email' : 
            update = {emailAddress : e.target.value}
                break;
            default:
                break;
        }
        setContactInput(Object.assign({}, contactInput,update))
        props.onInputChange(update)
    }

    return (
        <div 
            className="ns-fieldset" 
            id={props.id + "-form"}>
                <div className={"ns-fieldset" + (!isFirstNameValid() ? " ns-fieldset-message-error" : "")}>
                    <label 
                        className="ns-label"
                        id={props.id + "-first-name-label"} 
                        htmlFor={props.id + "-first-name"}>
                            {"First name"}
                    </label>
                    {!isFirstNameValid() && 
                    <span id={props.id + "-first-name-error"} className="ns-error-message field-validation-error">
                        {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_FIRST_NAME_EMPTY)}
                    </span>}
                    <input 
                        className={"fw-20" + (isFirstNameValid() ? " ns-input" : " ns-input--error")}
                        disabled={props.disabled}
                        type="text" 
                        autoComplete="given-name"
                        id={props.id + "-first-name"} 
                        name={props.id + "-first-name"}
                        onInput={onInputChange}
                        value={props.disabled ? "" : contactInput.firstName} />
                </div>
                <div className={"ns-fieldset" + (!isLastNameValid() ? " ns-fieldset-message-error" : "")}>
                    <label
                        className="ns-label" 
                        id={props.id + "-last-name-label"} 
                        htmlFor={props.id + "-last-name"}>
                            {"Last name"}
                    </label>
                    {!isLastNameValid() && 
                    <span id={props.id + "-last-name-error"} className="ns-error-message field-validation-error">
                        {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_LAST_NAME_EMPTY)}
                    </span>
                    }
                    <input 
                        className={"fw-20 " + (isLastNameValid() ? "ns-input" : "ns-input--error")}
                        disabled={props.disabled}
                        type="text" 
                        autoComplete="family-name"
                        id={props.id + "-last-name"} 
                        name={props.id + "-last-name"} 
                        onInput={onInputChange}
                        value={props.disabled ? "" : contactInput.lastName} />
                </div>
                <div className={"ns-fieldset" + (!isPhoneNumberValid() ? " ns-fieldset-message-error" : "")}>
                    <label
                        className="ns-label" 
                        id={ props.id + "-phone-label"} 
                        htmlFor={props.id + "-phone"}>
                            {"Phone number"}
                    </label>
                    {!isPhoneNumberValid() && 
                        <span id={props.id + "-phone-error"} className="ns-error-message field-validation-error">
                            {ErrorWithString(phoneNumberErrorString())}
                        </span>
                    }
                    <input 
                        className={"fw-20 " + (isPhoneNumberValid() ? "ns-input" : "ns-input--error")}
                        type="tel"
                        disabled={props.disabled} 
                        id={props.id + "-phone"}
                        name={props.id + "-phone"}
                        onInput={onInputChange} 
                        autoComplete="tel"
                        value={props.disabled ? "" : contactInput.phoneNumber} />
                </div>
                <div className={"ns-fieldset" + (!isEmailValid() ? " ns-fieldset-message-error" : "")}>
                    <label
                        className="ns-label"
                        id={props.id + "-email-label"} 
                        htmlFor={props.id + "-email"}>
                            {"Email"}
                    </label>
                    {!isEmailValid() && 
                        <span id={props.id + "-email-error"} className="ns-error-message field-validation-error">
                            {ErrorWithString(emailErrorString())}
                        </span>}
                    <input 
                        className={"fw-20 " + (!isEmailValid() ? "ns-input--error" : "ns-input")}
                        type="email"
                        disabled={props.disabled}
                        autoComplete="email" 
                        id={props.id + "-email"} 
                        name={props.id + "-email"} 
                        onInput={onInputChange}
                        value={props.disabled ? "" : contactInput.emailAddress} />
                </div>
        </div>
    )
}

export default ContactDetailsInputForm
